module.exports = __webpack_public_path__ + "media/src/public/img/payment/ruble-3d6fe818c726c7cf66a62f866daeb6db.svg";